export const normalizeReviewScore = (value) => {
  if (value == null || value === '') return null;

  const score = Number(value);
  if (!Number.isFinite(score) || score <= 0 || score > 5) return null;

  return score;
};
